import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { Control, Controller } from "react-hook-form";
import { CreateCalendarEventForm } from "app/services/api/types/calendar/requests/CreateCalendarEventForm";
import { FormControlledInput } from "ui/molecules/form/FormControlledInput";
import {
  CheckboxGroup,
  Checkbox,
  CheckboxIndicator,
  CheckboxIcon,
  CheckboxLabel,
} from "ui/gluestack/checkbox";
import {
  FormControl,
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
} from "ui/gluestack/form-control";
import { AlertCircleIcon, CheckIcon } from "ui/gluestack/icon";
import { numberValidation, requiredValidation } from "ui/utils/Validators";
import { WEEKDAYS } from "app/constants/dateConstants";

interface Props {
  control: Control<CreateCalendarEventForm>;
}

export function WeeklyRecurrenceOptions({ control }: Props) {
  return (
    <View className="flex gap-4">
      <View className="flex-row items-center ">
        <FormControlledInput
          id="recurrence_rule.weekly.interval"
          name="recurrence_rule.weekly.interval"
          control={control}
          placeholder="1"
          isRequired
          prefix={<Text className="text-base text-gray-600 mr-2">Every</Text>}
          postfix={
            <Text className="text-base text-gray-600 ml-2">week(s)</Text>
          }
          className="flex-row items-center"
          textInputClassName="flex-1 max-w-10"
          rules={{
            validate: numberValidation,
            required: requiredValidation("Weekly interval"),
          }}
        />
      </View>

      <Controller
        control={control}
        name="recurrence_rule.weekly.week_day"
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          const stringValue = value?.map(String) || [];

          return (
            <FormControl isInvalid={!!error}>
              <CheckboxGroup
                value={stringValue}
                onChange={(selected) =>
                  onChange(selected.map((val) => parseInt(val, 10)))
                }
                className="flex-row gap-4 flex-wrap"
              >
                {WEEKDAYS.map((day) => (
                  <Checkbox key={day.value} value={day.value} size="sm">
                    <CheckboxIndicator>
                      <CheckboxIcon as={CheckIcon} />
                    </CheckboxIndicator>
                    <CheckboxLabel>{day.label}</CheckboxLabel>
                  </Checkbox>
                ))}
              </CheckboxGroup>
              {error && (
                <FormControlError>
                  <FormControlErrorIcon
                    as={AlertCircleIcon}
                    className="text-error-500"
                    size="sm"
                  />
                  <FormControlErrorText className="text-error-500 text-sm">
                    {error.message}
                  </FormControlErrorText>
                </FormControlError>
              )}
            </FormControl>
          );
        }}
        rules={{
          validate: (value) =>
            value?.length > 0 || "At least one weekday must be selected",
        }}
      />
    </View>
  );
}
